import React, { Component } from 'react';
import { Button, Select, Form } from 'library';
import $ from 'jquery';

import { HEADER_HEIGHT } from 'constants';

const calculate_distance = (p1, p2) => {
    return Math.sqrt(Math.pow(p2.lat - p1.lat, 2) + Math.pow(p2.lng - p1.lng, 2));
};

const dist2 = (v, w) => { return Math.sqrt((v[0] - w[0]) ** 2 + (v[1] - w[1]) ** 2); }

const distToSegment = (point, segmentStart, segmentEnd) => {
    const segmentLengthSquared = dist2(segmentStart, segmentEnd) ** 2;
    if (segmentLengthSquared === 0) return dist2(point, segmentStart);
    let projectionParameter = ((point[0] - segmentStart[0]) * (segmentEnd[0] - segmentStart[0]) + (point[1] - segmentStart[1]) * (segmentEnd[1] - segmentStart[1])) / segmentLengthSquared;
    projectionParameter = Math.max(0, Math.min(1, projectionParameter));
    return dist2(point, [segmentStart[0] + projectionParameter * (segmentEnd[0] - segmentStart[0]), segmentStart[1] + projectionParameter * (segmentEnd[1] - segmentStart[1])]);
}

const get_bearing = (p1, p2) => {
    const y = p2[0] - p1[0];
    const x = p2[1] - p1[1];
    const angle = Math.atan2(y, x) * 180 / Math.PI;
    return (angle + 360) % 360;
};

const get_cardinal_direction = (p1, p2) => {
    console.log("Get Cardinal Direction", p1, p2);
    var bearing = get_bearing(p1, p2)
    const directions = ['South', 'South East', 'East', 'North East', 'North', 'North West', 'West', 'South West'];
    return directions[Math.round(bearing / 45) % 8];
};

class NearbyLocation extends Component {
    handleClick = () => {
        if (this.props.pan_to_location && this.props.location) {
            this.props.pan_to_location(this.props.location);
        }
    };

    render() {
        return (
            <span
                onClick={this.handleClick}
                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue', marginRight: '2px' }}
            >
                {this.props.location.name},
            </span>
        );
    }
}

export default class Directions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start_location: {},
            end_location: {},
            flight_distance: null,
            walking_path: null,
            walking_distance: null,
            directions: [],
            error: null,
            height: null,
            focused: false,
        };

    }

    componentDidMount() {
        // Set initial size
        this.calculate_size();
        // Update size
        window.addEventListener('resize', this.calculate_size);
    }

    calculate_size = () => {
        this.setState({
            height: $(window).height() - HEADER_HEIGHT,
        });
    };

    clear = () => {
        this.setState({
            start_location: {},
            end_location: {},
            flight_distance: null,
            walking_path: null,
            walking_distance: null,
            directions: [],
            error: null,
            focused: false,
        });
    }

    focus = () => {
        this.setState({ focused: true });
    };

    set_location = (new_state, return_func) => {
        var locations = this.props.locations;
        for (var location of locations) {
            if (location.id == new_state.start_location_id) {
                new_state.start_location = location;
            }
            if (location.id == new_state.end_location_id) {
                new_state.end_location = location;
            }
        }
        this.setState(new_state, this.calculate_directions);
        return_func();
    }

    calculate_directions = () => {
        var start_location = this.state.start_location;
        var end_location = this.state.end_location;
        if (!start_location || !end_location || !start_location.id || !end_location.id) return;

        var locations = [];
        var roads = [];
        for (var location of this.props.locations) {
            if (location.geojson.geometry && location.geojson.geometry.coordinates && location.geojson.geometry.coordinates.length > 0) {

                let coords = location.geojson.geometry.coordinates;

                let lat_lng_list = []
                for (let i = 0; i < coords.length; i += 2) {
                    lat_lng_list.push([coords[i] + location.lat, coords[i + 1] + location.lng]);
                }

                roads.push({
                    id: location.id,
                    name: location.name,
                    points: lat_lng_list
                });
            }
            else {
                locations.push(location);
            }
        }

        var walking_path = [];
        try {
            walking_path = this.get_walking_path(roads);
            let nearby_ids = [];
            let i = 0;
            while (walking_path.length > i + 1) {
                if (i == 0 || i == walking_path.length - 2) {
                    let starting_location = walking_path[i];
                    var starting_point = starting_location.point;
                    if (starting_location.all_points) {
                        starting_point = starting_location.all_points[starting_location.all_points.length - 1];
                    }

                    let next_location = walking_path[i + 1];
                    let next_point = next_location.point;
                    if (next_location.all_points) {
                        next_point = next_location.all_points[0];
                    }

                    var nearby_locations = this.find_nearby_locations(starting_point, next_point, nearby_ids);
                    nearby_ids = nearby_ids.concat(nearby_locations.map(loc => loc.id));

                    walking_path[i].nearby_locations = nearby_locations;
                }

                if (i != walking_path.length - 2) {
                    let next_location = walking_path[i + 1];

                    let nearby_location_list = [];
                    if (next_location.all_points) {
                        for (let j = 0; j < next_location.all_points.length - 1; j++) {
                            let point = next_location.all_points[j];
                            let destination = next_location.all_points[j + 1];
                            let nearby_locations = this.find_nearby_locations(point, destination, nearby_ids);
                            nearby_location_list.push(...nearby_locations);
                        }
                    }

                    walking_path[i + 1].nearby_locations = nearby_location_list;
                }

                i++;
            }

        }
        catch (e) {
            console.log(e);
        }

        if (this.props.update_paths) {
            var flight_path_points = [start_location.lat, start_location.lng, end_location.lat, end_location.lng];
            var walking_path_points = [];
            for (var location of walking_path) {
                if (location.all_points) {
                    for (var point of location.all_points) {
                        walking_path_points.push(...point);
                    }
                }
                else {
                    walking_path_points.push(...location.point);
                }
            }
            this.props.update_paths(flight_path_points, walking_path_points);
        }

        var dist = calculate_distance(start_location, end_location);
        var flight_distance = dist * this.props.coordinate_distance;

        var nearby_flight_locations = this.find_nearby_locations([start_location.lat, start_location.lng], [end_location.lat, end_location.lng], []);

        this.setState({
            flight_distance: flight_distance,
            walking_path: walking_path,
            error: null,
            nearby_flight_locations: nearby_flight_locations
        });
    };

    find_nearby_locations = (start_point, end_point, nearby_ids = []) => {
        // Find nearby locations for each step
        const threshold = 50;
        const start_id = this.state.start_location.id;
        const end_id = this.state.end_location.id;
        var nearby_locations = [];

        this.props.locations.forEach(loc => {
            if (loc.id == start_id || loc.id == end_id) return;

            var dist = distToSegment([loc.lat, loc.lng], start_point, end_point);

            if (dist < threshold && !nearby_ids.includes(loc.id)) {
                nearby_locations.push(loc);
                nearby_ids.push(loc.id);
            }
        });

        return nearby_locations;
    };


    get_walking_path = (roads) => {
        if (roads.length == 0) return [];
        const road_dictionary = {};

        for (const road of roads) {
            road_dictionary[road.id] = {
                id: road.id,
                name: road.name,
                points: road.points
            };
        }


        var path = [];
        var connections = {};

        // Iterate through all pairs of roads to find connections
        for (let i = 0; i < roads.length; i++) {
            const road1 = roads[i];
            for (let j = i + 1; j < roads.length; j++) {
                const road2 = roads[j];

                // Check segment intersections
                for (let road_1_index = 0; road_1_index < road1.points.length - 1; road_1_index++) {
                    const p1 = road1.points[road_1_index];

                    for (let road_2_index = 0; road_2_index < road2.points.length - 1; road_2_index++) {
                        const p2 = road2.points[road_2_index];
                        let max_dist = Infinity;
                        if (connections[road1.id] && connections[road1.id][road2.id]) {
                            max_dist = connections[road1.id][road2.id].distance;
                        }
                        if (dist2(p1, p2) < max_dist) {
                            max_dist = dist2(p1, p2);
                            if (connections[road1.id] == undefined) {
                                connections[road1.id] = {};
                            }
                            if (connections[road2.id] == undefined) {
                                connections[road2.id] = {};
                            }
                            connections[road1.id][road2.id] = {
                                road_point: p1,
                                connecting_point: p2,
                                connection_name: road2.name,
                                road_index: road_1_index,
                                connection_index: road_2_index,
                                distance: max_dist,
                            }
                            connections[road2.id][road1.id] = {
                                road_point: p2,
                                connecting_point: p1,
                                connection_name: road1.name,
                                road_index: road_2_index,
                                connection_index: road_1_index,
                                distance: max_dist,
                            }
                        }
                    }
                }
            }
        }

        //get the nearest point on roads to the start and end locations
        var start_location = this.state.start_location;
        var end_location = this.state.end_location;
        var start_to_road_dict = {}
        var end_to_road_dict = {}
        for (var road of roads) {
            start_to_road_dict[road.id] = { 'distance': Infinity, 'point': null };
            end_to_road_dict[road.id] = { 'distance': Infinity, 'point': null };
            let i = -1;

            for (var point of road.points) {
                i++;
                var start_distance = dist2(point, [start_location.lat, start_location.lng]);
                if (start_distance < start_to_road_dict[road.id].distance) {
                    start_to_road_dict[road.id] = { 'distance': start_distance, 'point': point, 'connecting_index': i };
                }
                var end_distance = dist2(point, [end_location.lat, end_location.lng]);
                if (end_distance < end_to_road_dict[road.id].distance) {
                    end_to_road_dict[road.id] = { 'distance': end_distance, 'point': point, 'connecting_index': i };
                }
            }
        }

        var offroad_penalty = 10;
        //from start location, check end location distances with penalty
        var start_to_end_distance = dist2([start_location.lat, start_location.lng], [end_location.lat, end_location.lng]);
        var start_to_end_distance_with_penalty = start_to_end_distance * offroad_penalty;
        //from each closest road point to start location, check end location distances with out penalty, choose closest
        var last_road = null;
        for (let road_id in start_to_road_dict) {
            var start_to_road_distance = start_to_road_dict[road_id].distance * offroad_penalty;
            var road_to_end_distance = end_to_road_dict[road_id].distance;
            var total_distance = start_to_road_distance + road_to_end_distance;
            if (total_distance < start_to_end_distance_with_penalty) {
                start_to_end_distance_with_penalty = total_distance;
                last_road = road_id;
            }
        }

        var starting_location = { 'point': [start_location.lat, start_location.lng], 'name': start_location.name, 'id': start_location.id };
        var end_location = { 'point': [end_location.lat, end_location.lng], 'name': end_location.name, 'id': end_location.id };
        if (!last_road) {
            return [starting_location, end_location];
        }
        else {
            path = [starting_location, { 'point': start_to_road_dict[last_road].point, 'name': road_dictionary[last_road].name, 'id': last_road, 'connecting_index': start_to_road_dict[last_road].connecting_index }];
        }

        //from for each point on the road, check end location distance with no road penalty, but offroad penalty.
        //check each road intersection to see if it is closer to the end location
        var last_location = path[path.length - 1];
        var previous_locations = [last_road];
        while (last_location.point != end_location.point) {
            var last_point = last_location.point;
            last_road = null;
            var last_point_to_end_distance = end_to_road_dict[last_location.id].distance * offroad_penalty + dist2(last_point, end_to_road_dict[last_location.id].point);
            for (let road_id in connections[last_location.id]) {
                if (previous_locations.includes(road_id)) {
                    continue;
                }
                var road_to_end_distance = end_to_road_dict[road_id].distance + connections[last_location.id][road_id].distance * offroad_penalty + dist2(end_to_road_dict[road_id].point, connections[last_location.id][road_id].connecting_point) + dist2(last_point, connections[last_location.id][road_id].road_point);
                if (road_to_end_distance < last_point_to_end_distance) {
                    last_point_to_end_distance = road_to_end_distance;
                    last_road = road_id;
                }
            }

            var all_points = [];
            let connecting_index = last_location.connecting_index;
            let new_connecting_index = null;
            if (last_road && last_road != last_location.id) {
                new_connecting_index = connections[last_location.id][last_road].road_index
            }
            else {
                new_connecting_index = end_to_road_dict[last_location.id].connecting_index
            }

            const currentRoad = road_dictionary[last_location.id];
            const step = connecting_index < new_connecting_index ? 1 : -1;
            let segmentDistance = 0;

            for (let i = connecting_index; ; i += step) {
                const point = currentRoad.points[i];
                all_points.push(point); // Collect points for this segment

                if (i !== connecting_index) {
                    const prevPoint = currentRoad.points[i - step];
                    segmentDistance += dist2(prevPoint, point); // Sum up distance
                }

                if (i === new_connecting_index) break;
            }

            last_location.all_points = all_points
            last_location.distance = segmentDistance
            if (all_points.length > 1) {
                console.log("All Points Before Direction", all_points)
                last_location.orientation = get_cardinal_direction(all_points[0], all_points[all_points.length - 1])
            }

            if (last_road && last_road != last_location.id) {
                previous_locations.push(last_road);
                path.push({
                    'point': connections[last_location.id][last_road].connecting_point,
                    'name': road_dictionary[last_road].name,
                    'id': last_road,
                    'connecting_index': connections[last_location.id][last_road].connection_index,
                });
                last_location = path[path.length - 1];
            }
            else {
                path.push(end_location);
                break;
            }
        }
        console.log("Walking Path", path)
        return path;

    }

    render() {
        var locations = this.props.locations;
        var location_options = locations.map(loc => ({ text: loc.name, value: loc.id }));

        let direction_button = (
            <Button
                className="round-btn"
                style={{
                    padding: '6px 11px',
                    fontSize: '20px',
                    position: 'absolute',
                    top: '-3px',
                    left: '-3px',
                    transition: 'opacity .2s',
                    zIndex: 8,
                    opacity: this.state.focused ? 0 : 1,
                    boxShadow: '2px 2px 10px rgba(0,0,0,.5)',
                }}
                type="primary"
                onClick={this.focus}
            >
                <i class="bi bi-signpost-split"></i>
            </Button>
        );

        if (!this.state.focused) {
            return (
                <div style={{ zIndex: 5 }}>
                    {direction_button}
                </div>
            );
        }

        var flight_distance_display = null;
        if (this.state.flight_distance) {
            var unit = 'feet'
            var flight_distance = this.state.flight_distance;
            if (flight_distance > 2640) {
                unit = 'miles'
                flight_distance = flight_distance / 5280;
            }

            let nearby_locations = [];
            for (let loc of this.state.nearby_flight_locations) {
                nearby_locations.push(<NearbyLocation location={loc} pan_to_location={this.props.pan_to_location} />);
            }

            flight_distance_display = (
                <div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
                    <p><strong>Flight:</strong> {flight_distance.toFixed(2)} {unit}</p>
                    {nearby_locations.length > 0 && (
                        <div style={{ fontSize: '0.9em', color: '#666', marginTop: '4px' }}>
                            Locations You'll Pass: {nearby_locations}
                        </div>
                    )}
                </div>
            );
        }

        var walking_path_display = null;
        try {
            let total_distance = 0;
            let walking_path_steps = [];
            if (this.state.walking_path) {
                let path_index = 0;

                while (this.state.walking_path.length > path_index + 1) {
                    console.log("Path Index", path_index, this.state.walking_path.length);
                    if (path_index == 0 || path_index == this.state.walking_path.length - 2) {
                        let starting_location = this.state.walking_path[path_index];
                        var starting_point = starting_location.point;
                        if (starting_location.all_points) {
                            starting_point = starting_location.all_points[starting_location.all_points.length - 1];
                        }

                        let next_location = this.state.walking_path[path_index + 1];
                        let next_point = next_location.point;
                        if (next_location.all_points) {
                            next_point = next_location.all_points[0];
                        }
                        console.log("Points", starting_point, next_point);
                        let orientation = ''
                        if (starting_point && next_point) {
                            orientation = get_cardinal_direction(starting_point, next_point);
                        }
                        else {
                            console.log("Missing Point", starting_location, next_location);
                        }
                        console.log("Orientation", orientation);
                        let unit = 'feet'
                        let distance = dist2(starting_point, next_point) * this.props.coordinate_distance;
                        total_distance += distance;
                        if (distance > 2640) {
                            unit = 'miles'
                            distance = distance / 5280;
                        }
                        var nearby_locations = [];
                        if (path_index == 0 && starting_location.nearby_locations) {
                            nearby_locations = starting_location.nearby_locations;
                        }
                        else if (path_index == this.state.walking_path.length - 2 && next_location.nearby_locations) {
                            nearby_locations = next_location.nearby_locations;
                        }
                        let nearby_location_display = [];
                        for (let loc of nearby_locations) {
                            nearby_location_display.push(<NearbyLocation location={loc} pan_to_location={this.props.pan_to_location} />);
                        }
                        walking_path_steps.push(
                            <div>
                                <p>Head {orientation} for {distance.toFixed(2)} {unit} to {next_location.name}</p>
                                {nearby_locations.length > 0 && (
                                    <div style={{ fontSize: '0.9em', color: '#666', marginTop: '4px' }}>
                                        Locations You'll Pass: {nearby_location_display}
                                    </div>
                                )}
                            </div>
                        );
                    }

                    if (path_index != this.state.walking_path.length - 2) {
                        let next_location = this.state.walking_path[path_index + 1];

                        let unit = 'feet'
                        let distance = next_location.distance * this.props.coordinate_distance;
                        total_distance += distance;
                        if (distance > 2640) {
                            unit = 'miles'
                            distance = distance / 5280;
                        }
                        if (next_location.distance < 5) {
                            path_index++;
                            continue;
                        }

                        var nearby_locations = [];
                        if (next_location.nearby_locations) {
                            nearby_locations = next_location.nearby_locations;
                        }
                        let nearby_location_display = [];
                        for (let loc of nearby_locations) {
                            nearby_location_display.push(<NearbyLocation location={loc} pan_to_location={this.props.pan_to_location} />);
                        }
                        walking_path_steps.push(
                            <div style={{ borderTop: '1px solid #ccc', paddingTop: '4px' }}>
                                <p>Continue {next_location.orientation} on {next_location.name} for {distance.toFixed(2)} {unit}</p>
                                {nearby_location_display.length > 0 && (
                                    <div style={{ fontSize: '0.9em', color: '#666', marginTop: '4px' }}>
                                        Locations You'll Pass: {nearby_location_display}
                                    </div>
                                )}
                            </div>
                        );
                    }
                    path_index++;
                }

            }
            let unit = 'feet'
            if (total_distance > 2640) {
                unit = 'miles'
                total_distance = total_distance / 5280;
            }
            var total_distance_display = null;
            if (total_distance > 0) {
                total_distance_display = (
                    <p><strong>Total Walking Distance:</strong> {total_distance.toFixed(2)} {unit}</p>
                )
            }
            walking_path_display = (
                <div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
                    {total_distance_display}
                    {walking_path_steps}
                </div>
            );
        }
        catch (e) {
            console.log(e);
        }

        let clear_button = (
            <Button
                className="round-btn right-floater"
                type="danger"
                onClick={this.clear}
            >
                <i class="bi bi-x"></i>
            </Button>
        );

        return (
            <div className="directions-container" style={{ padding: '10px', backgroundColor: 'rgba(255,255,255,0.9)', borderRadius: '5px', maxHeight: `${this.state.height - 100}px`, overflowY: 'auto' }}>
                {clear_button}
                <h3>Directions</h3>
                <Form submit={this.set_location} submit_text="Get Directions">
                    <Select
                        label="From:"
                        name="start_location_id"
                        value={this.state.start_location.id}
                        options={location_options}
                    />
                    <Select
                        label="To:"
                        name="end_location_id"
                        value={this.state.end_location.id}
                        options={location_options}

                    />
                </Form>

                {flight_distance_display}
                {walking_path_display}
            </div >
        );
    }
}
